import { render } from "./multa.vue?vue&type=template&id=e6d35224&scoped=true"
import script from "./multa.vue?vue&type=script&lang=js"
export * from "./multa.vue?vue&type=script&lang=js"

import "./multa.vue?vue&type=style&index=0&id=e6d35224&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6d35224"]])

export default __exports__